const DateTime = ({ date, language }: { date?: string; language: string }) => {
    if (!date) return '';

    if (language === 'en') {
        return new Date(date).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    } else {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();
        return `${year}年${month}月${day}日`;
    }
};

export default DateTime;